<!-- 支付链接 -->
<template>
  <div class="">

    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img v-if="orderInfo.payType=='alipay'" src="/imgs/title_zfb.jpg" />
        <img v-if="orderInfo.payType=='weixin'" src="/imgs/title_wx.jpg" />
        <img v-if="orderInfo.payType=='douyin'" src="/imgs/title_douyin.png" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!--支付链接-->
    <div class="pannel-btn" v-if="orderInfo.orderId">
      <!--支付宝-->
      <div v-if="orderInfo.payType=='alipay'&&orderInfo.payUrl">
        <a :href="orderInfo.payUrl" class="btn btn-alip" style="width: 70%;">立即支付</a>
      </div>
      <!--微信-->
      <div v-else-if="orderInfo.payType=='weixin'&&orderInfo.payUrl">
        <a :href="orderInfo.payUrl" class="btn btn-weix" style="width: 70%;">立即支付</a>
      </div>
      <div v-else>
        <a class="btn btn-other" style="width: 70%;">这是什么</a>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">超时支付，修改金额，修改支付方式，重复支付，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">次日前未查，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：支付成功确认时间<span style="color: red;">5-10分钟</span>,付款后<span style="color: red;">超过10分钟</span>还未到账,请联系客服查单补单!
      </p>
    </div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
